"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _Box = _interopRequireDefault(require("../../../Layout/Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var Shimmer = function Shimmer(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      _c = _a.count,
      count = _c === void 0 ? 3 : _c,
      sx = _a.sx,
      props = (0, _tslib.__rest)(_a, ["variant", "count", "sx"]);
  var lines = new Array(count);
  var highlight = 'rgba(0, 0, 0, 0.0)'; // TODO: use theme-ui variables

  var lowlight = 'rgba(0, 0, 0, 0.1)';
  return React.createElement(React.Fragment, null, _lodash.default.map(lines, function (_line, index) {
    return React.createElement(_Box.default, (0, _tslib.__assign)({
      __themeKey: "skeletons",
      key: index
    }, props, {
      sx: (0, _tslib.__assign)({
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        backgroundImage: "linear-gradient(\n              to right, " + lowlight + " 0%,\n              " + highlight + " 0%,\n              " + lowlight + " 40%,\n              " + highlight + " 100%\n            )",
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        height: '16px',
        width: '100%',
        marginBottom: 2,
        animationDuration: '1.5s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        animationName: 'placeholderShimmer',
        animationTimingFunction: 'linear',
        '@keyframes placeholderShimmer': {
          '0%': {
            backgroundPosition: '-2000px 0'
          },
          '100%': {
            backgroundPosition: '2000px 0'
          }
        },
        variant: "skeletons." + variant + ".root"
      }, sx)
    }));
  }));
};

Shimmer.displayName = 'Shimmer';
var _default = Shimmer;
exports.default = _default;